import { menuRU, menuEN } from '~/data/menu';

export const useMenu = () => {
  const { isInternational } = useInternational();

  return isInternational ? menuEN : menuRU;
};
